import React from 'react';
import { Table, Collapse, Label } from 'reactstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

/**
 * Componente para pré-visualizar dados de um arquivo importado em uma tabela recolhível.
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {Array<Array<string>>} props.data - Matriz de dados a ser exibida. A primeira linha é o cabeçalho.
 * @param {boolean} props.isOpen - Controla se a pré-visualização está aberta ou recolhida.
 * @param {Function} props.toggle - Função para alternar o estado de abertura da pré-visualização.
 * @returns {JSX.Element} O componente de pré-visualização de dados.
 */
const DataPreview = ({ data, isOpen, toggle, showAllRows = false }) => {
  if (!data || data.length === 0) {
    return null;
  }

  const headers = data[0] || [];
  const rows = showAllRows ? data : data.slice(1, 5);
  const hasMoreRows = data.length > 5;
  const remainingRows = data.length - 5;

  return (
    <div className="mb-4">
      <Label
        className="form-control-label mb-2 d-flex align-items-center"
        onClick={toggle}
        style={{ cursor: 'pointer' }}
      >
        Pré-visualização dos dados
        <span className="ml-2">
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </Label>
      <Collapse isOpen={isOpen}>
        <div>
          <Table responsive striped hover size="sm" className="mb-0">
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex} style={{ color: '#8898aa' }}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
              {hasMoreRows && !showAllRows && (
                <tr>
                  <td
                    colSpan={headers.length || 1}
                    className="font-italic"
                    style={{ color: '#5c6887' }}
                  >
                    ... e mais {remainingRows} registros
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Collapse>
    </div>
  );
};

export default DataPreview;
